export function slideIn(element: any, directionFrom: string) {
    var coordinate = coor(directionFrom);
    var value = trnslt(directionFrom) || 0;

    element.style.transform =
        "translate" + coordinate + "(" + value + "%); -ms-translate" + coordinate + "(" + value + "%)";
    var tick = function () {
        if (value > 100) {
            value -= 100;
        } else if (value < -100) {
            value += 100;
        } else if (value > 0) {
            value -= 1;
        } else if (value < 0) {
            value += 1;
        }
        element.style.transform = "translate" + coordinate + "(" + value + "%)";
        if (value !== 0) {
            requestAnimationFrame(tick);
        }
    };
    tick();
}

export function fadeIn(element: HTMLElement, cb?: () => void) {
    let time = 500;
    element.style.opacity = "0";
    element.style.transition = "opacity ease-in " + time + "ms";
    setTimeout(() => (element.style.opacity = "1"), 0);
    setTimeout(() => cb && cb(), time);
}

export function fadeOut(element: HTMLElement, cb?: () => void) {
    let time = 500;
    element.style.opacity = "1";
    element.style.transition = "opacity ease-out " + time + "ms";
    setTimeout(() => (element.style.opacity = "0"), 0);
    setTimeout(() => cb && cb(), time);
}

function trnslt(directionFrom: string) {
    if (directionFrom == "right") {
        return window.innerWidth;
    } else if (directionFrom == "left") {
        return -window.innerWidth;
    } else if (directionFrom == "top") {
        return -window.innerHeight;
    } else if (directionFrom == "bottom") {
        return window.innerHeight;
    }
    return 0;
}

function coor(directionFrom: string) {
    if (directionFrom == "right" || directionFrom == "left") {
        return "X";
    }
    if (directionFrom == "top" || directionFrom == "bottom") {
        return "Y";
    }
    throw "direction from was unparsable [" + directionFrom + "]";
}
